/* ============================================================
   TIMELESS — wishlist (localStorage)
   No backend, no app, no login required. Persists per browser.
   Stores an array of {handle, id} so the wishlist page can
   re-render saved items by fetching each product's card markup.

   For a cross-device wishlist tied to a customer account, this
   would need an app or metafield backend — out of scope for a
   theme. This covers the standard premium-theme behaviour.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'timeless:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: list }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function toggle(handle, id) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx > -1) { list.splice(idx, 1); } else { list.push({ handle: handle, id: id }); }
    write(list);
    return idx === -1; // true if now added
  }
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  // Reflect saved state on any heart buttons present on the page.
  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      btn.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    });
  }

  // Toggle on click (event-delegated so it works on lazy-loaded cards).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var added = toggle(btn.getAttribute('data-handle'), btn.getAttribute('data-id'));
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
  });

  /* ---------- WISHLIST PAGE RENDER ---------- */
  // On the wishlist page, fetch each saved product's card and inject it.
  async function renderWishlistPage() {
    var mount = document.querySelector('[data-wishlist-grid]');
    if (!mount) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');

    if (list.length === 0) {
      if (empty) empty.style.display = '';
      mount.innerHTML = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    // Pull each product's rendered card via the product URL + view param.
    var cards = await Promise.all(list.map(async function (item) {
      try {
        var res = await fetch('/products/' + item.handle + '?view=card');
        if (!res.ok) return '';
        var html = await res.text();
        return html.trim();
      } catch (e) { return ''; }
    }));

    mount.innerHTML = cards.filter(Boolean).join('');
    syncButtons(mount);
  }

  /* ---------- INIT ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    syncButtons();
    renderWishlistPage();
  });
  // run immediately too in case DOM already parsed
  updateCount();
  syncButtons();
})();
